import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export default function PageTitleBar({ title, children }) {
  return (
    <Box
      display="flex"
      paddingLeft="0.24rem"
      sx={{ alignItems: "center", marginBottom: "0.6rem" }}
    >
      <Typography variant="h5">{title}</Typography>
      <Box sx={{ flexGrow: 1, display: "flex" }} />
      <Box>{children}</Box>
    </Box>
  );
}
